<template>
    <Spin fix v-if="options.showToast">
        <div
            class="spin-box"
            :style="
                'background-color: rgba(255,255,255,' + options.opacity + ')'
            ">
            <!-- <img
                class="img"
                src="@/assets/login/logo.png"
                alt=""
                v-if="options.txt == 'UpLoading...'" /> -->
            <img class="img1" src="@/assets/login/logo1.png" alt="" />
            <div class="loading" v-if="options.txt == 'Creating...'">
                <Icon type="ios-loading" size=50 class="demo-spin-icon-load"></Icon>
            </div>
            <div class="pro-div" v-if="options.txt == 'loading...' || options.txt == 'UpLoading...'">
                <Progress 
                    class="pro" text-inside
                    :percent="options.progress"
                    :stroke-width="12"
                    stroke-color="#4945FF" />
            </div>
            <div class="load-txt" v-if="options.txt == 'Creating...' || options.txt == 'UpLoading...'">
                {{ options.txt }}
            </div>

            <div class="footer-box" v-if="options.txt == 'loading...' || options.txt == 'Creating...'" >
                <div class="m-title">
                    Large Language Model-Driven 3D Avatar Presentations and chat
                    with Your PowerPoint/Slides.
                </div>
                <div class="s-title">www.slidesorator.com</div>
            </div>
        </div>
    </Spin>
</template>

<script setup>
import { Spin, Icon, Progress } from "view-ui-plus";
import { ref, watch, getCurrentInstance } from "vue";
const opt = defineProps({
    options: {
        type: Object,
        default: {},
    },
});

watch(
    () => opt.options.progress,
    (newValue, oldValue) => {
        console.log(newValue);
    }
);
</script>

<style lang="less">
.ivu-spin-fix {
    z-index: 99999 !important;
    background-color: transparent !important;
}
.ivu-progress-inner {
    background: #fff !important;
}
.ivu-progress-inner-text {
    height: 8px !important;
    line-height: 0;
}
</style>
<style lang="less" scoped>
.loading {
    position: absolute;
    left: 50%;
    top: 48%;
    transform: translate(-50%, -50%);

}
.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
    transform-origin: center;
}

.spin-box {
    height: 100vh;
    width: 100vw;
    position: relative;
}
.img {
    width: 172px;
    height: 36px;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
}

.img1 {
    width: 254px;
    height: 151px;
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
}
.pro-div {
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
    width: 50%;
    height: 15px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 1px 2px;
}
.load-txt {
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    margin-top: 30px;
}

.footer-box {
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    .m-title {
        font-size: 16px;
        color: rgba(61, 61, 61, 1);
        font-weight: 500;
    }
    .s-title {
        font-size: 14px;
        color: rgba(61, 61, 61, 0.5);
        font-weight: 400;
    }
}
@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
        
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
